<div class="textarea-container">
  @if (placeholder) {
    <label class="label" [attr.for]="id">
      {{ placeholder | translate }}
    </label>
  }

  <div
    class="wrapper"
    [class.error]="control && control.errors && control.touched"
    [class.focused]="shouldFocus"
    [class.highlight]="highlight"
    [ngClass]="size"
    >
    @if (control) {
      <textarea
        #textarea
        [id]="id"
        [formControl]="control"
        class="textarea"
        [attr.rows]="rows"
        [readOnly]="readOnly"
        [mentionConfig]="mentionConfig"
        (focus)="onFocus()"
        placeholder=""
      ></textarea>
    } @else {
      <textarea
        #textarea
        [id]="id"
        [value]="initialValue || ''"
        class="textarea"
        [attr.rows]="rows"
        [readOnly]="readOnly"
        [mentionConfig]="mentionConfig"
        (focus)="onFocus()"
        placeholder=""
      ></textarea>
    }

  </div>
</div>
